const steps = [
  {
    step: '01',
    title: 'Find Your Category',
    description: 'Browse the dropdown menu or category cards to select the product type you are interested in. Each category is carefully organized with verified product listings.',
    icon: 'ri-search-line',
  },
  {
    step: '02',
    title: 'Compare Products',
    description: 'Review side-by-side product details including pricing, sizing charts, material information, and community QC photos to make informed comparisons.',
    icon: 'ri-scales-3-line',
  },
  {
    step: '03',
    title: 'Review Information',
    description: 'Check real buyer reviews, QC verification photos, and community feedback to ensure product quality before making any purchasing decisions.',
    icon: 'ri-file-list-3-line',
  },
  {
    step: '04',
    title: 'Visit Main Website',
    description: 'Click through to the main website for the full product listing, detailed specifications, and a seamless shopping experience with secure checkout.',
    icon: 'ri-external-link-line',
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            Simple Process
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            How the Vigorbuy Spreadsheet Works
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Getting started with the Vigorbuy Spreadsheet is straightforward. Follow these 
            four simple steps to discover products, compare options, and shop with confidence.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={step.step} className="relative group">
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-200 h-full">
                <div className="flex items-center gap-3 mb-4">
                  <span className="font-heading text-3xl font-bold text-primary-200 group-hover:text-primary-300 transition-colors">
                    {step.step}
                  </span>
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className={`${step.icon} text-lg`}></i>
                  </span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-foreground-300 text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Start Exploring Now
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}